import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';
import { AddButton, Text } from 'ui_system/forms/FormStyles';

import { getUser, getBrand } from 'data_system/token_auth/selectors';

import {
  getExperiencesByLastUpdated,
  getExperiencesFetching,
} from 'data_system/resource_portal/selectors';

import {
  fetchExperiences,
  toggleNewExperienceModal,
} from 'data_system/resource_portal/actions/experienceActions';

import { t } from 'services/translation';

import ExperienceCard from './ExperienceCard';
import NewExperienceModal from './ui/NewExperienceModal';

const SubHeader = styled('div')`
  display: grid;
  padding: 20px;
`;

const ListWrapper = styled('div')`
  display: grid;
  padding: 0 20px 20px;
  border-top: solid 1px ${Theme.colors.lightLine};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding: 0px 16px 20px;
  }
`;

export const PlusSign = styled('span')`
  font-weight: 300;
  font-size: 30px;
  color: white;
  margin-right: 4px;
  position: relative;
  top: 5px;
`;

const CreateExperienceButton = styled(AddButton)`
  min-width: 140px;
  justify-self: end;
  color: white;
  line-height: 34px;
  padding: 0 1em;
  font-size: 16px;
  background-color: ${(props) =>
    props.color ? props.color : Theme.colors.green};
  text-transform: capitalize;
`;

const ExperienceList = () => {
  const dispatch = useDispatch();

  const experiences = useSelector(getExperiencesByLastUpdated);
  const experiencesFetching = useSelector(getExperiencesFetching);

  const brand = useSelector(getBrand);
  const { linkColor, slug: brandSlug } = brand;

  const resource = useSelector(getUser);
  const { isOnlineExperiencesAllowed } = resource.data.attributes;

  useEffect(() => {
    document.title = t('EXPERIENCES_LISTING');
    dispatch(fetchExperiences(resource.data.id));
  }, [dispatch]);
  const renderExperiences = () => {
    if (!experiencesFetching && experiences.length === 0) {
      const linkStyle = { color: linkColor, marginTop: 20, cursor: 'pointer' };
      return (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <Text block light>
            {t('THIS_IS_WHERE_ALL_OF_YOUR_CLASSES_WILL_APPEAR')}
          </Text>
          <Text
            block
            style={linkStyle}
            onClick={() => dispatch(toggleNewExperienceModal(true))}
          >
            <PlusSign style={{ color: linkColor }}>&#x2b;</PlusSign>{' '}
            {t('CREATE_YOUR_FIRST_CLASS')}
          </Text>
        </div>
      );
    }
    return (
      <React.Fragment>
        {experiences.map((experience) => {
          return (
            <ExperienceCard
              key={experience.id}
              loading={experiencesFetching}
              brandSlug={brandSlug}
              tour={experience}
              isOnlineExperiencesAllowed={isOnlineExperiencesAllowed}
            />
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <SubHeader>
        <CreateExperienceButton
          color={linkColor}
          onClick={() => dispatch(toggleNewExperienceModal(true))}
        >
          <PlusSign>&#x2b;</PlusSign> {t('CREATE_NEW')}
        </CreateExperienceButton>
      </SubHeader>
      <ListWrapper>
        <NewExperienceModal />
        {renderExperiences(experiences)}
      </ListWrapper>
    </React.Fragment>
  );
};

export default ExperienceList;
